import { BaseControl } from "../base-control";

class RecordIdControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope) {
    'ngInject';
    super(BaseControlService, $scope);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/recordid-control/recordid-control.component.html",
  controller: RecordIdControlCtrl
};